import variables from '../../variables';
import {isElement, loop, warn} from '../../helpers/_utilities';
import {$dom} from '../../helpers/dom';
import {$events} from '../../helpers/events';
import gsap from "gsap";
import is from 'is_js';

const {
	getAll,
	exist,
	attr,
	each
} = $dom;

export default function tabs(
	tabRootClassName = '.js-tabs',
	controlAttrName = 'data-tabs-control',
	contentAttrName = 'data-tabs-content',
	duration = .4
) {

	const
		controlSelector = `[${controlAttrName}]`,
		contentSelector = `[${contentAttrName}]`
	;

	if (exist([tabRootClassName, controlSelector, contentSelector])) {

		const targets = getAll(tabRootClassName);

		const _filterByAttr = (elsArray, targetAttr, compareAttr) => {

			let outputObj = {
				active: null,
				other: []
			};

			loop(elsArray, el => {
				if (attr(el, targetAttr) === compareAttr) {
					outputObj.active = el;
				} else {
					outputObj.other.push(el)
				}
			});

			return outputObj
		};

		const _getItemsByAttr = (attr, tabsRoot) => {
			return {
				controls: _filterByAttr(getAll(controlSelector, tabsRoot), controlAttrName, attr),
				content: _filterByAttr(getAll(contentSelector, tabsRoot), contentAttrName, attr)
			}
		};

		const _switchClassName = (target, action) => {
			if (isElement(target) || is.array(target)) $dom[action+'Class'](target, variables.classNames.active)
		};

		const changeTab = (anchor, tabsRoot) => {

			const {
				controls,
				content
			} = _getItemsByAttr(anchor, tabsRoot);

			try {
				_switchClassName([...controls.other, ...content.other], 'remove');
				_switchClassName([controls.active, content.active], 'add');

				if(content.other.length > 0) {
					gsap.to(content.other, {
						height: 0,
						autoAlpha: 0,
						duration
					});
				}

				if(isElement(content.active)) {
					gsap.to(content.active, {
						height: 'auto',
						autoAlpha: 1,
						duration
					});
				}
			} catch (e) {
				warn('Possibly incorrect id provided', 'tabs component');
			}

		};

		const toggleHandler = event => {
			const {target} = event;
			const tabsRoot = target.closest(tabRootClassName);

			if (isElement(tabsRoot)) {
				const btn = target.closest(controlSelector);
				if (isElement(btn)) changeTab(btn.getAttribute(controlAttrName), tabsRoot);
			}
		};

		const init = () => {
			each(targets, tab => {
				const
					content = getAll(contentSelector, tab),
					startTab = tab.dataset.initTab || content[0].dataset.tabsContent
				;

				if (content.length > 0) {
					gsap.set(content, {overflow: 'hidden'});
					changeTab(startTab, tab);
				}
			});

			$events.delegate.on('tap click', tabRootClassName, toggleHandler);
		};

		const destroy = () => {
			each(targets, tab => {
				const content = getAll(contentSelector, tab);

				if (content.length > 0) {
					gsap.set(content, {clearProps: 'overflow,height,opacity,visibility'});
				}
			});
			$events.delegate.off('tap click', tabRootClassName, toggleHandler);
		};

		return {init, destroy}
	}

	return null;
}
